import api from "@/config/api"
import { withLoading } from "@/store/helpers"

export default {
  namespaced: true,
  state: () => ({
    notifications: [],
    loading: false,
    unreadCount: null,
    allNotifications: [],
    allNotificationsTotal: 0,
    allNotificationsLoading: false,
    allNotificationsModalVisible: false
  }),
  mutations: {
    setNotifications(state, notifications) {
      state.notifications = notifications
    },
    setAllNotifications(state, { notifications, totalCount }) {
      state.allNotifications = notifications
      state.allNotificationsTotal = totalCount
    },
    setAllNotificationsLoading(state, loading) {
      state.allNotificationsLoading = loading
    },
    setAllNotificationsModalVisible(state, visible) {
      state.allNotificationsModalVisible = visible
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    setUnreadCount(state, unreadCount) {
      state.unreadCount = unreadCount
    }
  },
  actions: {
    async fetchNotifications(context) {
      return withLoading(async () => {
        const response = await api.get("/notifications")
        context.commit("setNotifications", response.data.notifications)
      }, context)
    },

    async bulkRead(context, ids) {
      return  withLoading(async () => {
        const response = await api.put("/notifications/bulk_read", { ids })
        context.commit("setUnreadCount", response.data.unread_count)
      }, context)
    },

    async fetchUnreadCount(context, ids) {
      return withLoading(async () => {
        const response = await api.get("/notifications/unread_count")
        context.commit("setUnreadCount", response.data.count)
      }, context)
    },

    async fetchAllNotifications(context, page = 1) {
      context.commit("setAllNotificationsLoading", true)
      try {
        const response = await api.get("/notifications/all", { params: { page } })
        context.commit("setAllNotifications", {
          notifications: response.data.notifications,
          totalCount: response.data.total_count
        })
      } finally {
        context.commit("setAllNotificationsLoading", false)
      }
    }
  },
}